
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom'; // Wrap with Router
import Routing from './Navigation/routing';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routing />
      {/* <Layout /> */}
    </Router>
  );
}

export default App;
